"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isEmptyDoc = function (argument) {
    return argument === "" || (Array.isArray(argument) && argument.length) === 0;
};
exports.default = isEmptyDoc;
